import { render, staticRenderFns } from "./ForgotPage.vue?vue&type=template&id=24ba7cca&"
import script from "./ForgotPage.vue?vue&type=script&lang=js&"
export * from "./ForgotPage.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports